import Vue from 'vue';
import Router from 'vue-router';
import rcLeaf from '@/mixins/rcLeaf';
import store from '@/store/index';

Vue.use(Router);

const BASIC_ROLE = 'user_roles_admin';

// meta by default has isPublic: false, and requiredRoles: [BASIC_ROLE]
const router = new Router({
  routes: [
    {
      path: '/',
      beforeEnter() {
        router.push({ name: store.state.app.user.touristicProvider ? 'sit_sheets_list' : 'clients_prestataires_list' });
      },
    },
    {
      path: '/unauthorized',
      name: 'no_permission',
      component: () => import('./views/RcUnauthorized.vue'),
      meta: { isPublic: true, title: 'unauthorized' },
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter() {
        if (process.env.NODE_ENV === 'production' && window.location.hostname !== 'localhost') {
          if (window.location.host === 'user.studio.raccourci.fr') {
            window.location =
              'https://connect.studio.raccourci.fr/oauth/v2/auth?client_id=3_582geteg4eckcwcscwo4kwwgcowk8cgo00cccksc0w040s8s4c&response_type=code&redirect_uri=https%3A%2F%2Fuser.studio.raccourci.fr%2Fv2%2Ferp%2Fcallback&state=cb3565edc82597263424562dc55d1d0445943f1f&application=users-admin';
          } else {
            window.location =
              'https://connect.studio.rc-check.com/oauth/v2/auth?client_id=3_582geteg4eckcwcscwo4kwwgcowk8cgo00cccksc0w040s8s4c&response_type=code&redirect_uri=https%3A%2F%2Fuser.studio.rc-preprod.com%2Fv2%2Ferp%2Fcallback&state=cb3565edc82597263424562dc55d1d0445943f1f&application=users-admin';
          }
        } else {
          window.location =
            'https://connect.studio.raccourci.fr/oauth/v2/auth?client_id=3_582geteg4eckcwcscwo4kwwgcowk8cgo00cccksc0w040s8s4c&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A8082%2Fv2%2Ferp%2Fcallback&state=cb3565edc82597263424562dc55d1d0445943f1f&application=users-admin';
        }
      },
      meta: { isPublic: true },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/Logout.vue'),
      meta: { isPublic: true, title: 'logout' },
      beforeEnter() {
        document.cookie = 'SESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'SESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/v2/erp';
        const scr = document.createElement('script');
        scr.src = 'https://connect.studio.raccourci.fr/oauth/v2/logout?redirect=/';
        document.body.appendChild(scr);
        setTimeout(() => {
          router.push('/login');
        }, 1000);
      },
    },
    {
      path: '/products/:productId(\\d+)',
      name: 'product_detail',
      component: () => import('./views/Products.vue'),
      meta: { title: 'details' },
    },
    {
      path: '/clients',
      component: () => import('./views/Clients/Clients.vue'),
      meta: { title: 'Comptes' },
      children: [
        {
          path: '',
          redirect: { name: 'clients_prestataires_list' },
        },
        {
          path: 'contacts',
          component: () => import('./views/Clients/Clients_Contacts.vue'),
          meta: { title: 'Contacts' },
          children: [
            {
              path: '',
              name: 'clients_contacts_list',
              component: () => import('./components/RcClients/RcClientsContactList.vue'),
            },
            {
              path: ':contactId(\\d+)',
              name: 'client_contact_detail',
              component: () => import('./views/Users/Users_Edit.vue'),
              meta: { title: 'contact' },
              children: [
                {
                  path: 'roles',
                  name: 'contact_roles',
                  component: () => import('./components/RcUserRoles/RcUserRoles.vue'),
                  meta: { type: 'contact' },
                },
                {
                  path: 'access',
                  name: 'contact_ambassador_access',
                  component: () => import('./components/RcAmbassadorAccess.vue'),
                  meta: { type: 'contact' },
                  children: [
                    {
                      path: 'userApplications',
                      name: 'contact_applications',
                      component: () => import('./components/RcContactApplications.vue'),
                      meta: { type: 'contact', tab: 0 },
                    },
                    {
                      path: 'loginHistory',
                      name: 'contact_login_history',
                      component: () => import('./components/RcIdpLoginsHistory.vue'),
                      meta: { type: 'contact', tab: 1 },
                    },
                    {
                      path: 'mailHistory',
                      name: 'contact_mail_history',
                      component: () => import('./components/RcIdpMailHistory.vue'),
                      meta: { type: 'contact', tab: 2 },
                    },
                  ],
                },
                {
                  path: 'ambassador',
                  name: 'contact_ambassador',
                  component: () => import('./components/RcRouterComponent.vue'),
                  children: [
                    {
                      path: 'host',
                      name: 'contact_ambassador_host',
                      component: () => import('./components/RcUserContact/RcUserContactProfile.vue'),
                      meta: { type: 'host' },
                    },
                    {
                      path: 'blogger',
                      name: 'contact_ambassador_blogger',
                      component: () => import('./components/RcUserContact/RcUserContactProfile.vue'),
                      meta: { type: 'blogger' },
                    },
                    {
                      path: 'greeter',
                      name: 'contact_ambassador_greeter',
                      component: () => import('./components/RcUserContact/RcUserContactProfile.vue'),
                      meta: { type: 'greeter' },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: 'prestataires',
          component: () => import('./views/Clients/Clients_Prestataires.vue'),
          meta: { title: 'Comptes' },
          children: [
            {
              path: '',
              name: 'clients_prestataires_list',
              component: () => import('./components/RcClients/RcClientsList.vue'),
            },
            {
              path: ':clientId(\\d+)',
              name: 'client_prestataire_detail',
              component: () => import('./components/RcClients/RcClientsPrestataireDetail.vue'),
              meta: { title: 'Compte' },
              children: [
                // {
                //   path: 'roles',
                //   name: 'client_roles',
                //   component: () => import('./components/RcUserRoles/RcUserRoles.vue'),
                //   meta: { type: 'clients' },
                // },
                {
                  path: 'sheets',
                  name: 'client_sheets',
                  component: () => import('./components/RcClients/RcClientSheets.vue'),
                },
                {
                  path: 'contacts',
                  name: 'client_contacts',
                  component: () => import('./components/RcClientContacts/RcClientContacts.vue'),
                },
                {
                  path: 'products',
                  name: 'client_products',
                  component: () => import('./components/RcClients/RcProducts.vue'),
                },
                {
                  path: 'roles',
                  name: 'client_roles',
                  component: () => import('./views/RcRolesWrapper.vue'),
                  meta: { type: 'client' },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/sheets',
      component: () => import('./views/Clients/Clients_SITSheets.vue'),
      meta: { title: 'Fiches SIT' },
      children: [
        {
          path: '',
          name: 'sit_sheets_list',
          component: () => import('./views/Sheets/Sheets_List.vue'),
        },
        {
          path: ':sheetId(\\d+)',
          name: 'sit_sheets_detail',
          component: () => import('./components/RcClients/RcSheetDetails.vue'),
          meta: { title: 'fiche' },
        },
      ],
    },
    {
      path: '/users',
      component: () => import('./views/Users/Users.vue'),
      meta: { title: 'Destination' },
      children: [
        {
          path: '',
          name: 'users_list',
          component: () => import('./views/Users/Users_List.vue'),
        },
        {
          path: ':contactId(\\d+)',
          name: 'user_detail',
          component: () => import('./views/Users/Users_Edit.vue'),
          meta: { title: 'utilisateur' },
          children: [
            {
              path: 'roles',
              name: 'user_roles',
              component: () => import('./views/RcRolesWrapper.vue'),
              meta: { type: 'user' },
            },
            {
              path: 'access',
              name: 'user_ambassador_access',
              component: () => import('./components/RcAmbassadorAccess.vue'),
              meta: { type: 'user' },
              children: [
                {
                  path: 'userApplications',
                  name: 'user_applications',
                  component: () => import('./components/RcContactApplications.vue'),
                  meta: { type: 'contact', tab: 0 },
                },
                {
                  path: 'mailHistory',
                  name: 'user_mail_history',
                  component: () => import('./components/RcIdpMailHistory.vue'),
                  meta: { type: 'user', tab: 0 },
                },
                {
                  path: 'loginHistory',
                  name: 'user_login_history',
                  component: () => import('./components/RcIdpLoginsHistory.vue'),
                  meta: { type: 'user', tab: 1 },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

function getRouteOptions(to) {
  const meta = typeof to.meta === 'undefined' ? { isPublic: false } : to.meta;
  if (typeof meta.requiredRoles === 'undefined') {
    // meta.requiredRoles = !meta.isPublic ? [BASIC_ROLE] : [];
    meta.requiredRoles = !meta.isPublic ? [] : [];
  }
  return meta;
}

function IHaveRoleIn(requiredRoles) {
  const { roles } = router.app.$store.state.app.user;
  return requiredRoles.every(role => roles.includes(role));
}

function handlePrivateRoute(to, next, routeOptions) {
  let redirectRoute;
  if (!routeOptions.isPublic) {
    if (!router.app.$store.state.app.logged) {
      redirectRoute = {
        name: 'login',
      };
    } else if (
      getRouteOptions(to).requiredRoles.length !== 0 &&
      !IHaveRoleIn(getRouteOptions(to).requiredRoles)
    ) {
      redirectRoute = {
        name: 'no_permission',
      };
    }
  }
  next(redirectRoute);
}

function mapRoute(path, params) {
  const routes = path.split('/');
  const mappedRoutes = routes.map((route) => {
    const matchResult = route.match(/:\w*/);
    if (matchResult) {
      const routeParam = matchResult[0].substring(1);
      if (params[routeParam]) {
        return params[routeParam];
      }
    }
    return route;
  });
  return mappedRoutes.join('/');
}

async function setBreadcrumbs(route) {
  const newRoute = route;
  const breadcrumbs = await Promise.all(newRoute.matched
    .filter(it => it.path.slice(-1) !== '/')
    .map(async (it) => {
      if (it.meta) {
        if (it.meta.title) {
          if (it.meta.title.action) {
            const newTitle = await router.app.$store.dispatch(`routes/${it.meta.title.action}`, newRoute.params);
            return {
              text: rcLeaf.methods.rcLeaf(newTitle, it.meta.title.path),
              to: mapRoute(it.path, newRoute.params),
            };
          }
          return {
            text: it.meta.title,
            to: mapRoute(it.path, newRoute.params),
          };
        }
      }
      return {};
    }));
  return breadcrumbs;
}

router.beforeEach(async (to, from, next) => {
  if (!['login', 'logout'].includes(to.name)) {
    setBreadcrumbs(to).then((breadcrumbs) => {
      router.app.$store.dispatch('routes/setBreadcrumbs', { breadcrumbs });
    });
    const routeOptions = getRouteOptions(to);
    if (!router.app.$store.state.app.initialized) {
      router.app.$store
        .dispatch('app/init')
        .catch(() => {
          next('/login');
        })
        .finally(() => {
          handlePrivateRoute(to, next, routeOptions);
        });
    } else {
      handlePrivateRoute(to, next, routeOptions);
    }
  } else {
    next();
  }
});

export default router;
